import TableDataFilterRadio from './table_data_filter_radio'

export default {
    install: function(Vue) {
        Vue.component('TableDataFilterRadio', TableDataFilterRadio)
    }
}
